import { createElement, styled, compose, position, space, layout, flexbox, color, typography, border, opacity, float, boxShadow, pointerEvents, boxSizing, visibility, transition, textOverflow, textDecoration, outline } from '@vebox/etui-system';

const ArticleElement = createElement('article');
const Article = styled(ArticleElement)(compose(position, space, layout, flexbox, color, typography, border, opacity, float, boxShadow, pointerEvents, boxSizing, visibility, transition, textOverflow, textDecoration, outline));
Article.displayName = 'Article';

export { Article };
